import React, { JSX } from 'react';
import { sanitize } from '@ibe/services';

interface Props {
  message: string;
  title?: string;
}

const ExclamationCircleIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    className="svg-inline--fa mr-2"
  >
    <path
      fill="currentColor"
      d="M100,200C44.78,200,0,155.22,0,100S44.78,0,100,0s100,44.78,100,100c0,26.52-10.54,51.96-29.29,70.71-18.71,18.82-44.17,29.36-70.71,29.29ZM102.08,130.63c-10.64-.42-19.6,7.88-20,18.51-.42,10.64,7.88,19.6,18.51,20,10.64.42,19.6-7.88,20-18.51,0-.21.02-.42.02-.63.45-10.24-7.49-18.9-17.73-19.35-.26,0-.53-.02-.79-.02h0ZM86.67,27.08l1.04,27.72,4.36,63.72h20l4.36-63.72,1.04-27.72h-30.81Z"
    />
  </svg>
);

export const CustomMessage = (props: Props): JSX.Element => {
  const { message, title } = props;

  return (
    <div className={`confirmation__alert alert`} role="alert">
      <div className="font-weight-bold">
        {title && <ExclamationCircleIcon />}
        {title}
      </div>
      {!title && <ExclamationCircleIcon />}
      <span dangerouslySetInnerHTML={{ __html: sanitize(message, true) }} />
    </div>
  );
};
